import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type EmptyStateType = 'no_folders' | 'no_documents' | 'no_results' | 'error' | 'waiting';

@Component({
  selector: 'app-document-empty-state',
  templateUrl: './document-empty-state.component.html',
  styleUrls: ['./document-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentEmptyStateComponent {
  @Input() type: EmptyStateType = 'waiting';
  @Input() customIcon: string;
  @Input() customTitle: string;
  @Input() customDescription: string;
  @Input() actionLabel: string;
  @Input() colors: { title_color?: string; text_content_color?: string; menu_color?: string };

  @Output() action = new EventEmitter<void>();

  private readonly config: Record<EmptyStateType, { icon: string; titleKey?: string; descKey?: string }> = {
    no_folders: {
      icon: 'assets/images/emptycontent/DOCUMENT.svg',
      titleKey: 'pages.documents.empty_content_title',
      descKey: 'pages.documents.empty_content_text',
    },
    no_documents: {
      icon: 'assets/images/emptycontent/DOCUMENT.svg',
      titleKey: 'pages.documents.empty_content_title',
      descKey: 'pages.documents.empty_content_text',
    },
    no_results: {
      icon: 'assets/images/emptycontent/AUCUNRESULTAT.svg',
      titleKey: 'global.texts.no_result_title',
      descKey: 'global.texts.no_result_text',
    },
    error: {
      icon: 'assets/images/emptycontent/DOCUMENT.svg',
      titleKey: 'global.alerts.generic_error',
      descKey: 'global.texts.waiting_for_content',
    },
    waiting: {
      icon: 'assets/images/emptycontent/DOCUMENT.svg',
      titleKey: null,
      descKey: 'global.texts.waiting_for_content',
    },
  };

  get icon(): string {
    return this.customIcon || this.config[this.type].icon;
  }

  get title(): string {
    return this.customTitle || this.config[this.type].titleKey || '';
  }

  get description(): string {
    return this.customDescription || this.config[this.type].descKey || '';
  }

  get showTitle(): boolean {
    return !!this.title;
  }

  onAction(): void {
    this.action.emit();
  }
}
